import { LangMinimumPrice, Name, Note } from '../../../../constant/languange'
import { connect, mapStateToProps, toRupiah } from '../../../../helpers/Common'

const SalesUnit = ({ redux, val }) => {
  return (
    <div className='table-responsive my-3 text-center'>
      <table className={`table table-sm ${redux.darkModeOn ? 'table-dark bg-dark' : ''}`}>
        <thead>
          <tr>
            <th scope='col' className='text-center align-middle' style={{ minWidth: 160 }}>{Name}</th>
            <th scope='col' className='text-center align-middle' style={{ minWidth: 160 }}>{LangMinimumPrice}</th>
            <th scope='col' className='text-center align-middle'>{Note}</th>
          </tr>
        </thead>
        <tbody>
          {val.map((item, i) => (
            <tr key={i}>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''}`}>{item?.name ?? ''}</td>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''}`}>{item?.min_price ? toRupiah(item?.min_price) : ''}</td>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''}`}>{item?.note ?? ''}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default connect(mapStateToProps)(SalesUnit)
